var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen.lock",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true, lock: true },
        },
      ],
      staticClass: "clearfix main_center",
    },
    [
      _c("div", { staticClass: "top-content busWinessLeft" }, [
        _c(
          "div",
          { staticClass: "left-navbar" },
          [
            _c(
              "el-button",
              {
                attrs: { size: "small" },
                on: {
                  click: function ($event) {
                    return _vm.back()
                  },
                },
              },
              [_vm._v("返回")]
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "right-content clearfix busWinessRight" },
        [
          _c("base-info", {
            attrs: { dateType: 2, projectInfo: _vm.project },
            on: {
              "update:projectInfo": function ($event) {
                _vm.project = $event
              },
              "update:project-info": function ($event) {
                _vm.project = $event
              },
            },
          }),
          _c(
            "el-card",
            { staticClass: "box-card", attrs: { shadow: "never" } },
            [
              _c(
                "div",
                { staticClass: "monitor-video" },
                [
                  _c(
                    "div",
                    { staticClass: "monitor-video-list" },
                    [
                      _c("videoPlayer", {
                        ref: "videoPlayerRef",
                        attrs: {
                          videoUrl: _vm.videoUrl,
                          videoCode: "mp4",
                          isShowControls: true,
                          keyIframeOffset: _vm.keyIframeOffset,
                          ifisShowControl: true,
                        },
                        on: {
                          "update:videoUrl": function ($event) {
                            _vm.videoUrl = $event
                          },
                          "update:video-url": function ($event) {
                            _vm.videoUrl = $event
                          },
                          "update:keyIframeOffset": function ($event) {
                            _vm.keyIframeOffset = $event
                          },
                          "update:key-iframe-offset": function ($event) {
                            _vm.keyIframeOffset = $event
                          },
                          switchCurrentVideo: _vm.switchVideoUrl,
                        },
                      }),
                    ],
                    1
                  ),
                  _c("placeAndEquipment", {
                    ref: "placeAndEquipmentRef",
                    attrs: {
                      roomType: _vm.openBidWitness_dataTypeObj.bidEvaluation,
                      abTop: "180px",
                      abRight: "62px",
                      currentVideo: _vm.currentVideo,
                      videoSwitchData: _vm.videoSrcData,
                    },
                    on: {
                      "update:currentVideo": function ($event) {
                        _vm.currentVideo = $event
                      },
                      "update:current-video": function ($event) {
                        _vm.currentVideo = $event
                      },
                      "update:videoSwitchData": function ($event) {
                        _vm.videoSrcData = $event
                      },
                      "update:video-switch-data": function ($event) {
                        _vm.videoSrcData = $event
                      },
                      switchCurrentVideo: _vm.switchVideoUrl,
                    },
                  }),
                ],
                1
              ),
            ]
          ),
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "form",
              staticStyle: { "margin-top": "12px", padding: "0px 24px" },
              attrs: { model: _vm.form, "label-width": "138px" },
            },
            [
              _c("div", { staticClass: "processStatus" }, [
                _vm.form.historyid == 2
                  ? _c("img", {
                      attrs: {
                        src: require("@/assets/images/status_record.png"),
                      },
                    })
                  : _vm._e(),
              ]),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "监督意见：",
                            prop: "superviseOpinion",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.form.superviseOpinion,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "superviseOpinion", $$v)
                                },
                                expression: "form.superviseOpinion",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("正常"),
                              ]),
                              _c("el-radio", { attrs: { label: 2 } }, [
                                _vm._v("需重点关注"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "", prop: "table" } },
                        [
                          _c(
                            "el-table",
                            {
                              ref: "dataTable",
                              staticStyle: { width: "100%" },
                              attrs: {
                                data: _vm.form.superviseitemList,
                                border: "",
                                stripe: "",
                                "header-cell-style":
                                  this.$globalGrayTableHeaderStyle,
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  label: "序号",
                                  prop: "index",
                                  align: "center",
                                  width: "100",
                                  "show-overflow-tooltip": true,
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return _c("div", {}, [
                                        _c("span", [
                                          _vm._v(_vm._s(scope.$index + 1)),
                                        ]),
                                      ])
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "监督内容",
                                  prop: "content",
                                  align: "left",
                                  "min-width": "140",
                                  "show-overflow-tooltip": true,
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "选项",
                                  align: "center",
                                  width: "150",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return _c(
                                        "div",
                                        {},
                                        [
                                          _c(
                                            "el-radio",
                                            {
                                              attrs: { label: 1, disabled: "" },
                                              model: {
                                                value: scope.row.value,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "value",
                                                    $$v
                                                  )
                                                },
                                                expression: "scope.row.value",
                                              },
                                            },
                                            [_vm._v("是")]
                                          ),
                                          _c(
                                            "el-radio",
                                            {
                                              attrs: { label: 0, disabled: "" },
                                              model: {
                                                value: scope.row.value,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "value",
                                                    $$v
                                                  )
                                                },
                                                expression: "scope.row.value",
                                              },
                                            },
                                            [_vm._v("否")]
                                          ),
                                        ],
                                        1
                                      )
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "备注",
                                  prop: "status",
                                  "show-overflow-tooltip": true,
                                  align: "left",
                                  "min-width": "80",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "监督记录：", prop: "remark" } },
                        [
                          _c("el-input", {
                            attrs: { type: "textarea", disabled: "", rows: 5 },
                            model: {
                              value: _vm.form.remark,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "remark", $$v)
                              },
                              expression: "form.remark",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 11 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "监督人：", prop: "superviseMan" } },
                        [
                          _c("el-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.form.superviseManName,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "superviseManName", $$v)
                              },
                              expression: "form.superviseManName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12, offset: 1 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "开标完成时间：" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              disabled: true,
                              type: "datetime",
                              placeholder: "选择时间",
                            },
                            model: {
                              value: _vm.form.endTime,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "endTime", $$v)
                              },
                              expression: "form.endTime",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "关键记录：" } },
                        [
                          _c(
                            "el-table",
                            {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.keyListLoading,
                                  expression: "keyListLoading",
                                },
                              ],
                              staticStyle: { width: "100%" },
                              attrs: {
                                data: _vm.tableDataDetail.slice(
                                  (_vm.pageIndex - 1) * _vm.pageSize,
                                  _vm.pageIndex * _vm.pageSize
                                ),
                                border: "",
                                stripe: "",
                                "row-style": { height: 60 + "px" },
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  "header-align": "center",
                                  label: "序号",
                                  width: "50",
                                  type: "index",
                                  align: "center",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "header-align": "center",
                                  label: "操作",
                                  width: "80",
                                  align: "center",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "text",
                                              size: "small",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.confirmPosition(
                                                  scope.row.timeDeviationSec,
                                                  scope.$index
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("定位")]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "recordTime",
                                  "header-align": "center",
                                  label: "时间",
                                  width: "180",
                                  align: "center",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "margin-left": "10px",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(scope.row.recordTimeStr)
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "快照",
                                  align: "center",
                                  width: "100",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        scope.row.screenshotUrl
                                          ? _c("img", {
                                              staticClass: "thumbnail",
                                              attrs: {
                                                src: scope.row.screenshotUrl,
                                                alt: "",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.showImgDialog(
                                                    scope.row.screenshotUrl
                                                  )
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "remark",
                                  "header-align": "center",
                                  "show-overflow-tooltip": true,
                                  label: "备注",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "margin-left": "10px",
                                            },
                                          },
                                          [_vm._v(_vm._s(scope.row.remark))]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                          _c("el-pagination", {
                            attrs: {
                              "hide-on-single-page": "",
                              "current-page": _vm.pageIndex,
                              "page-sizes": [10, 20, 50, 100],
                              "page-size": _vm.pageSize,
                              total: _vm.total,
                              layout: "total, sizes, prev, pager, next, jumper",
                            },
                            on: {
                              "size-change": _vm.sizeChangeHandle,
                              "current-change": _vm.currentChangeHandle,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "监督记录提交时间：" } },
                        [
                          _c("el-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.form.updateTime,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "updateTime", $$v)
                              },
                              expression: "form.updateTime",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.imgDialogVisible,
            width: "100%",
            height: "100%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.imgDialogVisible = $event
            },
            closed: _vm.dialogClose,
          },
        },
        [
          _c("img", {
            staticClass: "viewImg",
            attrs: { src: _vm.dialogImageUrl, alt: "" },
            on: {
              contextmenu: function ($event) {
                $event.preventDefault()
              },
            },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }